import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { PointOptionsObject } from 'highcharts';
import { sort } from 'remeda';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { sortByName } from 'src/app/utilities/commonSorters';
import { RevenueAllocationService } from '../revenue-allocation.service';

@Component({
  selector: 'lohi-revenue-allocation-graph',
  templateUrl: './revenue-allocation-graph.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RevenueAllocationGraphComponent implements OnInit, OnDestroy {
  private destroy$$ = new Subject();
  public chart: Chart;

  constructor(private revenueAllocationService: RevenueAllocationService) {}

  public ngOnInit(): void {
    this.chart = new Chart({
      chart: {
        type: 'column',
      },
      title: null,
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {},
      },
      series: [
        {
          name: 'Current',
          type: 'column',
        },
      ],
    });

    this.chart.ref$.pipe(take(1)).subscribe((ref) => {
      this.subscribeToGraphData(ref);
    });
  }

  public ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }

  private subscribeToGraphData(chart: Highcharts.Chart) {
    this.revenueAllocationService.graphData$.pipe(takeUntil(this.destroy$$)).subscribe((data) => {
      if (!data) {
        return;
      }

      const labels: string[] = [];
      const graphData: Array<PointOptionsObject> = [];
      const sortedCarriers = sort(data.graphData, (a, b) => {
        if (a.isPriority === b.isPriority) {
          return sortByName(a, b);
        }
        if (a.isPriority) {
          return -1;
        }
        return 1;
      });
      for (const entry of sortedCarriers) {
        labels.push(entry.name);
        graphData.push({
          y: entry.isPriority ? entry.current / 100 : entry.expectedEarnings / 100,
          color: entry.isPriority ? '#0e4eaf' : 'rgba(83, 104, 122, 0.333)',
        });
      }
      const series = this.chart.ref.series[0];
      series.setData(graphData);

      chart.xAxis[0].setCategories(labels);
    });
  }
}
